export default __webpack_public_path__ + "static/media/Pot1.158978e4.svg";